export const typeDefs = `
  union VoucherSalesHistorySortType = date | sales

  input VoucherSalesHistoryFilterInput {
    date: [String]
    sales: [Float]
    salesIncome: [Float]
    salesNetIncome: [Float]
    salesType: String
    downlineUsername: String
  }

  union SuperOrderIncomeHistorySortType =
    date
    | amount
    | netAmount
    | capacity
    | vault
    | locked

  input SuperOrderIncomeHistoryFilterInput {
    date: [String]
    amount: [Float]
    netAmount: [Float]
    capacity: [Float]
    vault: [Float]
    locked: [Float]
  }

  union UseIncomeHistorySortType =
    date
    | amount
    | netAmount
    | quantity
    | platformName
    | merchantName

  input UseIncomeHistoryFilterInput {
    date: String
    amount: Float
    netAmount: Float
    quantity: Int
    platformName: String
    merchantName: String
  }

  union RetailIncomeHistorySortType =
    date
    | amount
    | netAmount
    | quantity

  input RetailIncomeHistoryFilterInput {
    date: String
    amount: Float
    netAmount: Float
    quantity: Int
  }
`;
